"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Hamburger_1 = __importDefault(require("../../../assets/icons/Hamburger"));
const IC_ARROWUP_1 = __importDefault(require("../../../assets/icons/IC_ARROWUP"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const ModalMenu_1 = __importDefault(require("../../../components/modal/ModalMenu"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const ItemNoti_1 = __importDefault(require("./component/ItemNoti"));
const ItemNotiTweet_1 = __importDefault(require("./component/ItemNotiTweet"));
const styles_1 = __importDefault(require("./styles"));
function NotificationScreen(_props) {
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    const [isSelected, setSelection] = (0, react_1.useState)(true);
    const [isVisUser, setVisUser] = (0, react_1.useState)(true);
    const [isVisTweet, setVisTweet] = (0, react_1.useState)(true);
    const [isVisArticle, setVisArticle] = (0, react_1.useState)(true);
    const [isVisHistory, setVisHistory] = (0, react_1.useState)(true);
    const [isVisAdmin, setVisAdmin] = (0, react_1.useState)(true);
    const [dataNotiUser, setDataNotiUser] = (0, react_1.useState)([]);
    const [dataNotiTweet, setDataNotiTweet] = (0, react_1.useState)([]);
    const [dataNotiHistory, setDataNotiHistory] = (0, react_1.useState)([]);
    const [dataNotiArticle, setDataNotiArticle] = (0, react_1.useState)([]);
    const [dataNotiAdmin, setDataNotiAdmin] = (0, react_1.useState)([]);
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    (0, react_1.useEffect)(() => {
        if (connected) {
            if (dataUser?.user_id?.toString()) {
                if (isSelected) {
                    callListNotiUnRead()
                        .then(() => {
                    })
                        .catch((error) => {
                        console.error('Error fetching data:', error);
                    });
                }
                else {
                    callListNoti()
                        .then((resDataFirebase) => {
                        setDataNotiUser(resDataFirebase[0]),
                            setDataNotiTweet(resDataFirebase[1]);
                        setDataNotiArticle(resDataFirebase[2]);
                        setDataNotiAdmin(resDataFirebase[3]);
                        setDataNotiHistory(resDataFirebase[4]);
                    })
                        .catch((error) => {
                        console.error('Error fetching data:', error);
                    });
                }
            }
        }
    }, [isSelected, dataUser?.user_id?.toString(), connected]);
    const callListNoti = () => {
        return new Promise((resolve) => {
            //  const datamute = dataUser?.registration_status != 0 ?  [...listBlock, ...listMute] : [dataUser?.user_id]
            if (react_native_1.Platform.OS === 'web') {
                const { firebase } = require('../../../../web/firebase/config');
                try {
                    firebase
                        .firestore()
                        .collection('users')
                        .doc(dataUser?.user_id?.toString())
                        .collection('boxNotifications')
                        .orderBy('createdAt', 'desc')
                        .onSnapshot((snapshot) => {
                        let groupedData = [[], [], [], [], []];
                        snapshot.forEach(async (documentSnapshot) => {
                            const type = documentSnapshot?.data().type;
                            let dataNoti = documentSnapshot?.data();
                            dataNoti._id = documentSnapshot?.id;
                            if (type == 1) {
                                groupedData[0].push(dataNoti);
                            }
                            else if (type == 2) {
                                groupedData[1].push(dataNoti);
                            }
                            else if (type == 3) {
                                groupedData[2].push(dataNoti);
                            }
                            else if (type == 9) {
                                groupedData[3].push(dataNoti);
                            }
                            else if (type == 4) {
                                groupedData[4].push(dataNoti);
                            }
                        });
                        setDataNotiUser(groupedData[0]),
                            setDataNotiTweet(groupedData[1]);
                        setDataNotiArticle(groupedData[2]);
                        setDataNotiAdmin(groupedData[3]);
                        setDataNotiHistory(groupedData[4]);
                        resolve(groupedData);
                    });
                }
                catch (err) {
                    console.log('err', err);
                }
            }
        });
    };
    const callListNotiUnRead = () => {
        return new Promise((resolve) => {
            //  const datamute = dataUser?.registration_status != 0 ?  [...listBlock, ...listMute] : [dataUser?.user_id]
            if (react_native_1.Platform.OS === 'web') {
                const { firebase } = require('../../../../web/firebase/config');
                try {
                    firebase
                        .firestore()
                        .collection('users')
                        .doc(dataUser?.user_id?.toString())
                        .collection('boxNotifications')
                        .where('isRead', '==', 0)
                        .orderBy('createdAt', 'desc')
                        .onSnapshot((snapshot) => {
                        let groupedData = [[], [], [], [], []];
                        snapshot.forEach(async (documentSnapshot) => {
                            const type = documentSnapshot?.data().type;
                            let dataNoti = documentSnapshot?.data();
                            dataNoti._id = documentSnapshot?.id;
                            if (type == 1) {
                                groupedData[0].push(dataNoti);
                            }
                            else if (type == 2) {
                                groupedData[1].push(dataNoti);
                            }
                            else if (type == 3) {
                                groupedData[2].push(dataNoti);
                            }
                            else if (type == 9) {
                                groupedData[3].push(dataNoti);
                            }
                            else if (type == 4) {
                                groupedData[4].push(dataNoti);
                            }
                        });
                        setDataNotiUser(groupedData[0]),
                            setDataNotiTweet(groupedData[1]);
                        setDataNotiArticle(groupedData[2]);
                        setDataNotiAdmin(groupedData[3]);
                        setDataNotiHistory(groupedData[4]);
                        resolve(groupedData);
                    });
                }
                catch (err) {
                    console.log('err', err);
                }
            }
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
            paddingBottom: 70,
        } },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                    alignSelf: 'center',
                }, title: '通知・お知らせ', styleContainer: {
                    backgroundColor: 'white',
                }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                    setVisibleMenu(true);
                } })),
        react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.loginForm },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.mainCheck, { marginBottom: (0, scale_1.scale)(12) }] },
                    react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setSelection(!isSelected), style: { marginRight: (0, scale_1.scale)(8) } }, isSelected ? (react_1.default.createElement(react_native_1.View, { style: {
                            height: (0, scale_1.scale)(20),
                            width: (0, scale_1.scale)(20),
                            borderRadius: (0, scale_1.scale)(5),
                            borderWidth: 1,
                            borderColor: '#007AFF',
                            backgroundColor: '#007AFF',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(react_native_1.Image, { source: images_1.images.Check, style: { height: (0, scale_1.scale)(9.5), width: (0, scale_1.scale)(13) }, resizeMode: "cover" }))) : (react_1.default.createElement(react_native_1.View, { style: {
                            height: (0, scale_1.scale)(20),
                            width: (0, scale_1.scale)(20),
                            borderRadius: (0, scale_1.scale)(5),
                            borderWidth: 1,
                            borderColor: '#707070',
                        } }))),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTitle, onPress: () => setSelection(!isSelected) }, "\u672A\u958B\u5C01\u306E\u307F\u8868\u793A")),
                dataNotiAdmin?.length > 0 && (react_1.default.createElement(react_native_1.View, { style: { marginVertical: (0, scale_1.scale)(20) } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainCheck },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTitleTime }, "\u904B\u55B6\u304B\u3089\u306E\u304A\u77E5\u3089\u305B"),
                            !isVisAdmin && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setVisAdmin(!isVisAdmin), style: styles_1.default.buttonHideShowNoti },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textHide }, "\u8868\u793A\u3092\u6E1B\u3089\u3059"),
                                react_1.default.createElement(IC_ARROWUP_1.default, null)))),
                        dataNotiAdmin?.length > 1 ? (react_1.default.createElement(ItemNotiTweet_1.default, { notifications: dataNotiAdmin, onSelect: () => {
                                setVisAdmin(!isVisAdmin);
                            }, isVis: isVisAdmin })) : dataNotiAdmin?.length == 1 ? (react_1.default.createElement(ItemNoti_1.default, { data: dataNotiAdmin[0] })) : null))),
                dataNotiUser?.length > 0 && (react_1.default.createElement(react_native_1.View, { style: { marginVertical: (0, scale_1.scale)(20) } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainCheck },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTitleTime }, "\u30A2\u30AB\u30A6\u30F3\u30C8"),
                            !isVisUser && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setVisArticle(!isVisUser), style: styles_1.default.buttonHideShowNoti },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textHide }, "\u8868\u793A\u3092\u6E1B\u3089\u3059"),
                                react_1.default.createElement(IC_ARROWUP_1.default, null)))),
                        dataNotiUser?.length > 1 ? (react_1.default.createElement(ItemNotiTweet_1.default, { notifications: dataNotiUser, onSelect: () => {
                                setVisArticle(!isVisUser);
                            }, isVis: isVisUser })) : dataNotiUser?.length == 1 ? (react_1.default.createElement(ItemNoti_1.default, { data: dataNotiUser[0] })) : null))),
                dataNotiTweet?.length > 0 && (react_1.default.createElement(react_native_1.View, { style: { marginVertical: (0, scale_1.scale)(20) } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainCheck },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTitleTime }, "\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3"),
                            !isVisTweet && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setVisTweet(!isVisTweet), style: styles_1.default.buttonHideShowNoti },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textHide }, "\u8868\u793A\u3092\u6E1B\u3089\u3059"),
                                react_1.default.createElement(IC_ARROWUP_1.default, null)))),
                        dataNotiTweet?.length > 1 ? (react_1.default.createElement(ItemNotiTweet_1.default, { notifications: dataNotiTweet, onSelect: () => {
                                setVisTweet(!isVisTweet);
                            }, isVis: isVisTweet })) : dataNotiTweet?.length == 1 ? (react_1.default.createElement(ItemNoti_1.default, { data: dataNotiTweet[0] })) : null))),
                dataNotiArticle?.length > 0 && (react_1.default.createElement(react_native_1.View, { style: { marginVertical: (0, scale_1.scale)(20) } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainCheck },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTitleTime }, "\u8A18\u4E8B"),
                            !isVisArticle && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setVisArticle(!isVisArticle), style: styles_1.default.buttonHideShowNoti },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textHide }, "\u8868\u793A\u3092\u6E1B\u3089\u3059"),
                                react_1.default.createElement(IC_ARROWUP_1.default, null)))),
                        dataNotiArticle?.length > 1 ? (react_1.default.createElement(ItemNotiTweet_1.default, { notifications: dataNotiArticle, onSelect: () => {
                                setVisArticle(!isVisArticle);
                            }, isVis: isVisArticle })) : dataNotiArticle?.length == 1 ? (react_1.default.createElement(ItemNoti_1.default, { data: dataNotiArticle[0] })) : null))),
                dataNotiHistory?.length > 0 && (react_1.default.createElement(react_native_1.View, { style: { marginVertical: (0, scale_1.scale)(20) } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainCheck },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTitleTime }, "\u81EA\u5206\u53F2"),
                            !isVisHistory && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setVisHistory(!isVisHistory), style: styles_1.default.buttonHideShowNoti },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textHide }, "\u8868\u793A\u3092\u6E1B\u3089\u3059"),
                                react_1.default.createElement(IC_ARROWUP_1.default, null)))),
                        dataNotiHistory?.length > 1 ? (react_1.default.createElement(ItemNotiTweet_1.default, { notifications: dataNotiHistory, onSelect: () => {
                                setVisHistory(!isVisHistory);
                            }, isVis: isVisHistory })) : dataNotiHistory?.length == 1 ? (react_1.default.createElement(ItemNoti_1.default, { data: dataNotiHistory[0] })) : null))))),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) })));
}
exports.default = NotificationScreen;
